module.exports = __webpack_public_path__ + "static/media/1.question.107f6bab.mp4";